import React, { useEffect, useState } from 'react'
import { Box, Typography, Menu, MenuItem, styled, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { BottomSheetType } from 'src/types/SchoolType';
import { getPromoResult } from 'src/api/SchoolService';
import { PromoResultType } from 'src/types/SchoolType';
import { getDateDifference } from 'src/utils/DateUtils';

interface Props{
    school: BottomSheetType
}

// 필터 바 스타일링
const FilterBar = styled('div')({
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    backgroundColor:'white',
    });

// 필터 버튼 스타일링
const FilterButton = styled(Button)({ display: 'flex', alignItems: 'center', marginLeft: 8, backgroundColor: 'white', color: 'black' });

const ContentContainer = styled('div')({
    border: '1px solid #DDDDDD',
    padding: '10px',
    marginTop :'10px',
    borderRadius:'5px',
    marginBottom:'20px',
    minHeight:'60px'
})

const SchoolListDetailTab01 = ({school}:Props) => {
    const [data, setData] = useState<PromoResultType[] | null>(null)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [sortCriterion, setSortCriterion] = useState('최신순');

    useEffect(()=>{
        const fetchData = async ()=>{
            const response = await getPromoResult(school.school_class, school.school_id);
            const sorted = [...response.data].sort((a, b) =>
                new Date(b.visit_date).getTime() - new Date(a.visit_date).getTime())
            setData(sorted)
        }
        fetchData()
    },[])

    // 필터 버튼 클릭 이벤트 핸들러
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    };

            // 필터 메뉴 닫기 이벤트 핸들러
    const handleClose = (criterion: string = '') => {
        if (criterion) {
        setSortCriterion(criterion);
        sortSchools(criterion);
        }
        setAnchorEl(null);
    };

    // 학교 목록을 정렬하는 함수
    const sortSchools = (criterion: string) => {
        if (!data) return;
        const sortedSchools = [...data].sort((a, b) => {
            switch (criterion) {
            case '최신순':
                return new Date(b.visit_date).getTime() - new Date(a.visit_date).getTime();
            case '과거순':
                return new Date(a.visit_date).getTime() - new Date(b.visit_date).getTime();
            default:
                return 0;
            }
        });
        setData(sortedSchools);
        };

  return (
    <Box marginTop={'1px'}>
        <div style={{position:'sticky',borderBottom:'1px solid black', marginBottom:'10px'}}>
            <FilterBar>
                <Typography variant="body2" sx ={{color:'#7F7F89', fontSize:'12px', fontWeight:500}}>
                    총 <span style={{color:'black',fontSize:'16px'}}>{data?.length} </span>건
                    </Typography>
                <div>
                <FilterButton onClick={handleClick} endIcon={<ArrowDropDownIcon />}>
                    {sortCriterion}
                </FilterButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose()}>
                    <MenuItem onClick={() => handleClose('최신순')}>최신순</MenuItem>
                    <MenuItem onClick={() => handleClose('과거순')}>과거순</MenuItem>
                </Menu>
                </div>
            </FilterBar>
        </div>
        <div style={{overflowY:'auto', height:'calc(100vh - 570.14px)'}}>
            {data?.map((items, index) => {
                let bgColor = 'white';

                if (school.visited_at) {
                    const datediff = getDateDifference(items.visit_date);
                    if (datediff <= 180) bgColor = '#57C0AA';
                    else if (datediff <= 365) bgColor = '#5CA8E4';
                    else if (datediff <= 730) bgColor = '#F5BE49';
                    else bgColor = '#F57749';
                }
                const isLast = index === data.length - 1;
                return(
                <Box key={index} sx={{ marginBottom: isLast ? '0px':'16px', borderBottom: isLast ? 'none':'1px solid #DDDDDD', fontSize:'14px', lineHeight: 'normal' }}>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '15px' }}>
                    <Typography variant="body2" sx={{ backgroundColor: bgColor, color: 'white', padding: '3px 10px', borderRadius: '4px', marginRight: '10px', fontSize:'12px'}}>
                    D+{getDateDifference(items.visit_date)}
                    </Typography>
                    <Typography variant="body2" sx={{fontWeight:'bold', fontSize:'16px'}}>{items.visit_date}</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '5px' }}>
                    <Typography variant="body2" sx={{ width: '100px', color:'#7F7F89'}}>전체 학생</Typography>
                    <Typography variant="body2">{items.total_cnt}명</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '5px' }}>
                    <Typography variant="body2" sx={{ width: '100px', color:'#7F7F89'}}>참여자</Typography>
                    <Typography variant="body2" >{items.attendee_cnt}명</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '5px' }}>
                    <Typography variant="body2" sx={{ width: '100px', color:'#7F7F89'}}>관심표명자</Typography>
                    <Typography variant="body2" >{items.interested_cnt}명</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '5px' }}>
                    <Typography variant="body2" sx={{ width: '100px', color:'#7F7F89'}}>지원자</Typography>
                    <Typography variant="body2" >{items.apply_cnt}명</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ marginBottom: '10px' }}>
                    <Typography variant="body2" sx={{ width: '100px', color:'#7F7F89'}}>메모</Typography>
                </Box>
                <ContentContainer>{items.content}</ContentContainer>
                </Box>
            )})}
        </div>
        </Box>
  )
}

export default SchoolListDetailTab01